/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import NotificationsForm from "./NotificationsForm";
import Page from "../../shared/Page";
import GetItem from "../../../helpers/dataProviders/getItem";

class NotificationsFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Notification";
		this.id = props.match.params.id ? props.match.params.id : 0;
		this.state = {
			item: null,
		};
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<NotificationsForm
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
					initialValues={{ kind: "simple" }}
					getApi={this.props.getApi}
					notifications={this.props.items}
				/>
			</div>
		);
	};

	renderCopyForm = () => {
		const { item } = this.state;
		if (item === null) {
			GetItem(`/notifications/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		let initialValues = {};
		if (item) {
			let newTopics = item.topics.map(topic => {
				return topic.id;
			});
			initialValues = Object.assign({}, item, { topics: newTopics });
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Copy {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<NotificationsForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={initialValues}
						buttonLabel={`Create ${this.label}`}
						getApi={this.props.getApi}
						notifications={this.props.items}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		const { item } = this.state;
		if (item === null) {
			GetItem(`/notifications/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		let initialValues = {};
		if (item) {
			let newTopics = item.topics.map(topic => {
				return topic.id;
			});
			initialValues = Object.assign({}, item, { topics: newTopics });
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Update {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<NotificationsForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={initialValues}
						buttonLabel={`Update ${this.label}`}
						getApi={this.props.getApi}
						notifications={this.props.items}
						id={this.state.item.id}
						actionType="update"
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	render() {
		let content = "";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				content = "loading";
				break;
		}
		return <Page title="My Notifications">{content}</Page>;
	}
}

NotificationsFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
	topics: PropTypes.array,
	getApi: PropTypes.func,
};

export default withRouter(NotificationsFormWrapper);
